<template>
  <div>
    <div class="text-right pd-b-4">
      <el-button @click="csvExport" type="primary" round
        >ดาวน์โหลดข้อมูล</el-button
      >
    </div>
    <el-table
      v-if="showTable"
      :data="tableList"
      border
      :header-row-style="tableHeaderStyle"
      :header-cell-style="tableHeaderStyle"
      empty-text="ไม่พบข้อมูล"
      :default-sort="{ prop: 'index', order: 'ascending' }"
      class="disabled-on-print"
    >
      <el-table-column
        type="index"
        label="ลำดับ"
        header-align="center"
        align="center"
        width="80"
        sortable
      ></el-table-column>
      <el-table-column
        prop="nameTH"
        label="ชื่อ"
        header-align="center"
        align="center"
        sortable
        :width="widthMax < 767.98 ? '170' : ''"
      ></el-table-column>
      <el-table-column
        prop="surnameTH"
        label="นามสกุล"
        header-align="center"
        align="center"
        sortable
        :width="widthMax < 767.98 ? '170' : ''"
      ></el-table-column>
      <el-table-column
        prop="institution"
        label="ชื่อบริษัท"
        header-align="center"
        align="center"
        sortable
        :width="widthMax < 767.98 ? '170' : ''"
      ></el-table-column>
      <el-table-column
        prop="mobilephone"
        label="เบอร์โทรศัพท์"
        header-align="center"
        align="center"
        sortable
        :width="widthMax < 767.98 ? '170' : ''"
      ></el-table-column>
      <el-table-column
        prop="email"
        label="อีเมล"
        header-align="center"
        align="center"
        sortable
        :width="widthMax < 767.98 ? '170' : ''"
      ></el-table-column>
      <el-table-column
        :prop="fieldDate"
        :label="labelDate"
        :width="
          widthMax < 767.98
            ? '120'
            : widthMax < 1199
            ? '120'
            : widthMax > 1200
            ? '250'
            : ''
        "
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">{{
          scope.row[fieldDate] | dateTimeTh
        }}</template>
      </el-table-column>
      <el-table-column
        v-if="showAction"
        label
        width="100"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <div class="flex-display ai-center js-center">
            <div class="box-action">
              <div
                @click="
                  $router.push(
                    `/dashboard/user/score?courseId=${courseId}&userId=${scope.row._id}`
                  )
                "
                class="circle-action color-bg-secondary"
              >
                <i class="fas fa-eye"></i>
              </div>
            </div>
            <div class="box-action">
              <div
                @click="print(scope.row)"
                class="circle-action color-bg-secondary"
              >
                <i class="fas fa-print"></i>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { tableHeaderStyle } from "@/service/table";
import { HTTP } from "@/service/axios.js";

export default {
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  props: {
    tableList: {
      type: Array,
      default() {
        return [];
      },
    },
    showAction: {
      type: Boolean,
      default() {
        return false;
      },
    },
    labelDate: {
      type: String,
      default() {
        return "วันที่และเวลาที่สมัคร";
      },
    },
    fieldDate: {
      type: String,
      default() {
        return "createdAt";
      },
    },
    courseId: {
      type: String,
      default() {
        return "";
      },
    },
    exportName: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      widthMax: window.innerWidth,
      showTable: false,
    };
  },
  mounted() {
    window.addEventListener("resize", this.resize);
    setTimeout(() => {
      this.showTable = true;
    }, 200);
  },
  methods: {
    resize() {
      this.showTable = false;
      this.widthMax = window.innerWidth;
      setTimeout(() => {
        this.showTable = true;
      }, 200);
    },
    print(data) {
      this.$emit("print", data);
    },
    csvExport() {
      let columnsTemplate = [
        "ลำดับ",
        "ชื่อ",
        "นามสกุล",
        "ชื่อบริษัท",
        "เบอร์โทรศัพท์",
        "อีเมล",
        this.labelDate,
      ];

      let title = [];
      for (let index = 0; index < columnsTemplate.length; index++) {
        title.push(columnsTemplate[index]);
      }

      let data = [];
      for (let index = 0; index < this.tableList.length; index++) {
        let obj = {
          index: index + 1,
          nameTH: '"' + this.tableList[index].nameTH + '"',
          surnameTH: '"' + this.tableList[index].surnameTH + '"',
          institution: '"' + this.tableList[index].institution + '"',
          mobilephone: '"' + this.tableList[index].mobilephone + '"',
          email: '"' + this.tableList[index].email + '"',
          updatedAt: this.$options.filters.dateTimeTh(
            this.tableList[index][this.fieldDate]
          ),
        };
        data.push(obj);
      }
      let csvContent = "";
      csvContent += [
        title.join(","),
        ...data.map((item) => Object.values(item).join(",")),
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      var link = window.document.createElement("a");
      link.setAttribute(
        "href",
        "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvContent)
      );

      let dataFile =
        this.exportName +
        "_" +
        new Date().getDate() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        new Date().getFullYear();
      link.setAttribute("download", dataFile + ".csv");
      link.click();
    },
  },
};
</script>